import SharedLocal from '@/shared/services/persistence/drivers/Local'

export default new class Local extends SharedLocal {

}